import React from 'react';
import PropTypes from 'prop-types';

export const StrideConversationListItem = ({ name, cloudId, conversationId }) => (
  <div className="table-row">
    <div>
      <span className="name">{name}</span>
      <span className="actions">
        <a href={`https://app.stride.com/${cloudId}/chat/${conversationId}`}>Manage</a>
      </span>
    </div>
  </div>
);

StrideConversationListItem.propTypes = {
  name: PropTypes.string.isRequired,
  cloudId: PropTypes.string.isRequired,
  conversationId: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
};

const StrideConversations = ({ conversations }) => (
  <div className="cpt-table standard-two-row">
    <div id="stride-conversations" className="stride-conversations content">
      <div className="header">Connected conversations</div>
      { conversations.map(conversation => <StrideConversationListItem key={conversation.code} id={conversation.code} {...conversation} />) }
    </div>
  </div>
);

StrideConversations.propTypes = {
  conversations: PropTypes.arrayOf(PropTypes.shape(StrideConversationListItem.propTypes)).isRequired,
};

export default StrideConversations;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/stride_conversations.jsx